import { type TFunction } from "i18next";
import { Icon } from "icons";
import { type JSX } from "react";

export const workoutCardActions = {
  selectWorkout: "selectWorkout",
  copyWorkout: "copyWorkout",
  deleteWorkout: "deleteWorkout",
  exportToLibrary: "exportToLibrary",
} as const;

export type WorkoutCardAction =
  (typeof workoutCardActions)[keyof typeof workoutCardActions];

type ConfigFn = (context: { t: TFunction }) => {
  icon: JSX.Element | null;
  className: string;
  label: string;
};

export const workoutCardActionConfigs: Record<WorkoutCardAction, ConfigFn> = {
  [workoutCardActions.selectWorkout]: (context) => {
    return {
      icon: <Icon name="tabler-square-check" className="size-4" />,
      className: "",
      label: context.t("workoutCardMenu.select"),
    };
  },
  [workoutCardActions.copyWorkout]: (context) => {
    return {
      icon: <Icon name="tabler-copy" className="size-4" />,
      className: "",
      label: context.t("workoutCardMenu.copy"),
    };
  },
  [workoutCardActions.deleteWorkout]: (context) => {
    return {
      icon: <Icon name="tabler-trash" className="size-4 text-destructive" />,
      className: "text-destructive",
      label: context.t("workoutCardMenu.delete"),
    };
  },
  [workoutCardActions.exportToLibrary]: (context) => {
    return {
      icon: <Icon name="tabler-books" className="size-4" />,
      className: "",
      label: context.t("workoutCardMenu.exportToLibrary"),
    };
  },
};
